<template>
	<div class="stage stage--matchingquiz" :style="{ 'background-image': backgroundImage }">
		<div class="matchingquiz__background-overlay background-overlay">
		
			<div class="content-container">

				<div class="card">
					<div class="header__container">
						<div class="header" style="position: relative">
							{{questionData.header}}
						</div>
						<div class="subHeader">
		                    {{roundData.questions.subheader}}
		                </div>
						<div class="text" style="position: relative">{{questionData.questiontext}}</div>
					</div>


					<div class="btn__explanation" @click="showExplanationPopup">
						<i class="fa fa-question"></i>
					</div>

					<div class="buttonQuizContent">
		                <div class="image-box">
		                    <div v-if="questionData != null" class="shadow-box" style="touch-action: none; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
		                        <div class="image-box-table">
		                            <div class="base centered">
										<img :src="baseUrl + questionData.visual" style="pointer-events: none;" />


										<v-touch
											@panstart="onPanStart"
											@panmove="onPan"
											@panend="onPanEnd"
											class="shadow-box"
										>

											<div class="overlay">
												<div class="nav nav__prev">
													<span class="nav_button" @click="previous" :class="{'disabled':currentQuestion==0}"><i class="fa fa-angle-left fa-2x"></i></span>
												</div>
												<div class="nav nav__next">
													<span class="nav_button" @click="next" :class="{'disabled':lastQuestion}"><i class="fa fa-angle-right fa-2x"></i></span>
												</div>
											</div>

			
										</v-touch>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div v-if="questionData != null" class="button-conainer">
					<AnswerButton v-for="(answer , index) in questionData.answers"
					              :key="index"
					              :question="currentQuestion"
					              :index="index"
					              :answer="answers[index]"
					              :text="answer.answer_text"
					              :on-click="() => {onQuestionAnswer(index)}"
					/>
				</div>
				
			</div>

		</div>


		<ExplanationPopup 
			v-if="explanationPopupActive == true" 
			:additionalHTML="additionalHTML"
			:on-click="hideExplanationPopup"/>
		
	</div>
</template>

<script>
	import Score from '../../Score.vue';
	import Button from './Button.vue';
	import { url} from '../../../const/base';
	import { mapGetters , mapActions } from 'vuex';
	import ExplanationPopup from '../ExplanationPopup.vue';

	export default {

		components:{
			Score,
			AnswerButton : Button,
			ExplanationPopup,
		},

		data(){
			return{
				baseUrl : url,
				answerCount: -1,
				answers: [],
				explanationPopupActive: false,
				additionalHTML:"",
			}
		},

		beforeMount(){

			this.buildInfoAddonHTML();

			this.roundData.questions.questions.forEach((question)=>{
				if(this.answerCount == -1) this.answerCount = question.answers.length;
				else if(this.answerCount != question.answers.length) console.log("DATA of matching quiz incorrect");
				this.answers.push({answer:-1,question:-1});
			});
		},

		mounted(){
			this.showTransitorScore(true);
		},

		computed: {

			...mapGetters([
				"lastQuestion",
				"currentBlock",
				"currentStage",
				"currentRound",
				"currentQuestion",
				"roundCount",
				"stageData",
				"roundCompleted",
				"scores",
				"questionData",
				"stageCount",
				"roundScore",
				"roundData",
			]),

			backgroundImage: function() {
		        return 'url('+ this.baseUrl + this.roundData.questions.question_background + ')';
		    },

			finalScore(){
				let finalScore=0;
				let scores = 0;
				for(let score of this.scores[this.currentBlock][this.currentStage-1]){
					scores++;
					finalScore += score;
				}
				finalScore /= scores;
				return finalScore;
			},
		},


		methods:{

			...mapActions([
				"completeRound",
				"toNextQuestion",
				"toPreviousQuestion",
				"setRoundScore",
				"logAnswers",
				"logSdgs",
				"increaseTransitorScore",
                "showTransitorScore",
				'setNextButtonAction',
				'showNextButton',
				'hideNextButton',
			]),
			
			buildInfoAddonHTML(){
				this.additionalHTML = this.roundData.questions.rules;	
			},

			hideExplanationPopup(){
				this.explanationPopupActive = false;
				$('.btn--transition').removeClass('idle');
			},

			showExplanationPopup(){
				this.explanationPopupActive = true;
				$('.btn--transition').addClass('idle');
			},


			onPanStart(e){
				let img = this.$el.querySelector('.shadow-box');
				img.style.boxShadow = "0px 0px 5px #ee4357";
			},

			onPan(e){

				console.log(this.currentQuestion);

				let img = this.$el.querySelector('.shadow-box');
				let horizontal = e.deltaX;
				if(this.currentQuestion == 0 && horizontal < 0) horizontal = 0;
				else if(this.lastQuestion && horizontal > 0) horizontal = 0;
				img.style.transform = "translate("+horizontal+"px,0px)";

			},

			onPanEnd(e){
				let img = this.$el.querySelector('.shadow-box');
				img.style.transform = "translate(0px,0px)";


				img.style.boxShadow = "0px 0px 5px #ccc";

				if(Math.abs(e.deltaX) > 50){
					if(e.deltaX < 0){
						if(this.currentQuestion == 0) return;
						this.previous();
					}
					else{
						if(this.lastQuestion) return;
						this.next();
					}
				}
			},

			previous(){
				this.toPreviousQuestion();
			},

			next(){
				this.toNextQuestion();
			},


			completeMinigame(){

				let score = 0;
				let logAnswers = [];
				let mappedSdgs = [];

				this.answers.forEach((answerObj)=>{
					if((+this.roundData.questions.questions[answerObj.question].correct_answer)-1 == answerObj.answer){
						
						
						if(typeof this.roundData.questions.questions[answerObj.question].answers[answerObj.answer].sdg_mapping !== 'undefined'){
							
							console.log('sdgs mapping:');
							// console.log(answerObj.answer);
							// console.log(this.roundData.questions.questions[answerObj.question].answers[answerObj.answer].sdg_mapping);

							//check if it's a single entry or comma seperated
							let sdgMappingObject = this.roundData.questions.questions[answerObj.question].answers[answerObj.answer].sdg_mapping.split(",");

							console.log(sdgMappingObject);

							mappedSdgs[answerObj.question]=sdgMappingObject;
						}

						score ++;
					}

					logAnswers[answerObj.question]=answerObj.answer;


				});

				this.increaseTransitorScore(parseInt(this.roundData.questions.transitor_multiplier)*score);

				

				this.setRoundScore((score/this.roundData.questions.questions.length)*100).then(()=>{
					this.logAnswers(logAnswers).then(()=>{
						this.logSdgs(mappedSdgs).then(()=>{
							this.completeRound();
						});
					});

				});
			},

			onQuestionAnswer(e){


				let answered = false;
				if(this.answers[+e].question == this.currentQuestion){
					//console.log("Already set");
					this.answers[+e].answer = -1;
					this.answers[+e].question = -1;
					answered = true;
				}
				else{
					for(let i = 0 ; i < this.answers.length ; i++){
						if(this.answers[i].question == this.currentQuestion){
							//console.log("q["+i+"] is set to -1");
							this.answers[i].answer = -1;
							this.answers[i].question = -1;
						}
					}
					this.answers[+e].answer = +e;
					this.answers[+e].question = this.currentQuestion;
				}
				this.answers = this.answers.slice();



				// console.log(this.answers[+e].question);
				// console.log(this.answers[+e].answer);


				// console.log(this.currentQuestion+ ": " );
				// console.log(this.roundData.questions.questions[this.currentQuestion].correct_answer);
				// console.log('------------');

				let showButton = true;
				this.answers.forEach((answer)=>{
					if(answer.answer == -1) showButton = false;
				});

				if(showButton){
						this.setNextButtonAction(this.completeMinigame).then(()=>{
							setTimeout(()=>{
								this.showNextButton();
							});
						});
				}
				else{
					this.hideNextButton();
				}

				let toNextAllowed = true;
				if(!this.lastQuestion)
				{
					for(let i = 0 ; i < this.answers.length ; i++){
						if(this.answers[i].question == this.currentQuestion+1){
							toNextAllowed = false;
						}
					}
				}

				if(!this.lastQuestion && !answered && toNextAllowed) this.next();
				//console.log("");

			}
		}

	}
</script>



// WEBPACK FOOTER //
// src/components/minigames/matchingquiz/Index.vue